import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { sendReceiptByEmail, sendReceiptByText } from 'api/Transaction';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';
import { RECEIPT_CHANNELS, recordReceiptDelivery } from 'lib/helpers/receiptDelivery';

const SENDERS = {
  [RECEIPT_CHANNELS.EMAIL]: sendReceiptByEmail,
  [RECEIPT_CHANNELS.SMS]: sendReceiptByText
};

const SUCCESS_MESSAGES = {
  [RECEIPT_CHANNELS.EMAIL]: 'Receipt emailed',
  [RECEIPT_CHANNELS.SMS]: 'Receipt texted'
};

/**
 * Sends a receipt by email or text. The mutation takes optional contact overrides
 * (`toAltEmail`/`customEmail` or `toAltPhone`/`customPhone`). Errors show the backend's reason
 * (already sent, no consent, no phone on file, ...).
 *
 * @param {{ medium: 'email'|'sms', params: { transactionId?: number, appointmentId?: number, token?: string } }} args
 */
export const useSendReceipt = ({ medium, params }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCustomMutation({
    // Picks the contact keys so a click event passed straight to mutate never reaches the body.
    mutationFn: ({ toAltEmail, customEmail, toAltPhone, customPhone } = {}) =>
      SENDERS[medium](navigate, { ...params, toAltEmail, customEmail, toAltPhone, customPhone }),
    successMessage: SUCCESS_MESSAGES[medium],
    onSuccess: (data) => recordReceiptDelivery(queryClient, data?.delivery ?? {})
  });
};
